export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const PASSWORD_REGEX = /^.{8,}$/;
export const PASSWORD_REQUIREMENTS_MESSAGE =
  "Your password doesn't meet the requirements. Use at least 8 characters.";
export const NUMBER_REGEX = /^[0-9]+$/;
export const ALPHANUMERIC_REGEX = /^[a-zA-Z0-9 ]+$/;
export const URL_REGEX = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/;
export const NON_SPECIAL_CHAR_REGEX =
  /^(?!^[!@#$%^&*(),.?":{}|<> ]+$)[a-zA-Z0-9!@#$%^&*(),.?":{}|<> ]*$/;
export const PHONE_NUMBER_REGEX =
  /^(\+1[-\s]?)?(\([0-9]{3}\)|[0-9]{3})[-.\s]?[0-9]{3}[-.\s]?[0-9]{4}$/;

export const SUPPORT_EMAIL = "support@cybrbase.com";

// Standardised generic error shown on non-login pages when a request fails
// without a specific, user-appropriate message from the server.
export const GENERIC_ERROR_MESSAGE =
  "Something went wrong. Please try again in a few minutes.";

// Industry-standard connectivity error shown on the login screen, including a
// support contact line so users know how to get help if it persists.
export const LOGIN_CONNECTIVITY_ERROR_MESSAGE =
  `We're having trouble signing you in right now. Please try again in a few minutes. If the problem persists, contact ${SUPPORT_EMAIL}.`;

export const greenBar = {
  boxShadow: "0 6px 16px rgba(26, 79, 222, 0.28)",
  backgroundColor: "#0058be",
  color: "#FFFFFF",
};

export const yellowBar = {
  boxShadow: "0 6px 16px rgba(74, 81, 98, 0.22)",
  backgroundColor: "#4A5162",
  color: "#FFFFFF",
};

export const redBar = {
  boxShadow: "0 6px 16px rgba(26, 26, 46, 0.22)",
  backgroundColor: "#1A1A2E",
  color: "#FFFFFF",
};

export const ASSESSMENT_STATUS_COLORS = {
  Approved: "#0058be",
  "In Progress": "#4A5162",
  Archived: "#0F1117",
  Default: "#0F1117",
};

export const APP_BLACK_COLOR = "#0F1117";

export const ANSWERS = {
  "Not Answered": 0,
  Yes: 1,
  Incomplete: 2,
  No: 3,
};

export const PRE_ASSESSMENT_SCREENS = {
  WELCOME: "welcome",
  PREASSESSMENT: "preassessment",
  SUCCESS: "success",
};

export const RESPONSE_COLORS = {
  "Not Answered": "#8D93A1",
  Yes: "#0058be",
  No: "#1A1A2E",
  Incomplete: "#4A5162",
};

export const ROLES = {
  PLATFORM_ADMIN: "Platform Admin",
  COMPANY_ADMIN: "Company Admin",
  COMPANY_EMPLOYEE: "Company Employee",
  STATE_DOT_ADMIN: "State DOT Admin",
};

export const SURVEYS = {
  CRR: "CRR",
  CSF: "CSF",
};
